// extracted by mini-css-extract-plugin
export default {"Snackbar":"SnackBarAlert_Snackbar__oixtB","viewNotification":"SnackBarAlert_viewNotification__WQ-zc","closeBanner":"SnackBarAlert_closeBanner__1KkeN"};